import React from 'react';
import { PageHero } from '../components/PageHero';
import { SectionHeading } from '../components/SectionHeading';
import { ArtistCard } from '../components/ArtistCard';
import { images } from '../data/images';
import { artists } from '../data/artists';
export function Artists() {
  const piercers = artists.filter(a => a.isPiercer);
  return <>
      <PageHero title="Resident Artists" subtitle="Meet the people behind the skills" image={images.rick} data-id="element-247" data-mp="37yjqq5gj9klt" />
      <section className="mx-auto max-w-6xl px-6 py-20" data-id="element-248" data-mp="3ltvq4q5mvz92">
        <p className="mx-auto max-w-3xl text-center text-lg leading-relaxed text-ink-muted" data-id="element-249" data-mp="3hpo26v702nbw">
          Our shop is Artist owned and operated and we work with the most acclaimed, top notch, powerhouse Tattoo Artists. From beginning to end, we strive to give
          you the best experience possible as you leave wanting more!
        </p>
        <div className="mt-14 grid gap-x-6 gap-y-12 sm:grid-cols-2 lg:grid-cols-4" data-id="element-250" data-mp="21e0ucq7mmoff">
          {artists.map(artist => <ArtistCard key={artist.slug} artist={artist} data-id="element-251" data-mp="36v26p4y3s4uc" />)}
        </div>
      </section>

      {piercers.length > 0 && <section className="border-t border-ink-line py-20" data-id="element-252" data-mp="3bueq1fprmts6">
          <div className="mx-auto max-w-6xl px-6" data-id="element-253" data-mp="3fuoycz115wa7">
            <SectionHeading title="Piercing Artist" data-id="element-254" data-mp="3ftxf8nomdr0t" />
            <div className="mx-auto mt-12 grid max-w-xs gap-12" data-id="element-255" data-mp="3kmgnd54jfty8">
              {piercers.map(artist => <ArtistCard key={artist.slug} artist={artist} data-id="element-256" data-mp="3pjyq2drypcxs" />)}
            </div>
          </div>
        </section>}
    </>;
}